import { Contacts } from '@/modules/contacts/types';
import { all_roles } from '@/utils';

const access_roles = {
  [Contacts.Pages.CONTACTS]: all_roles,
};

export default access_roles;
